<template>
  <div class="saas-staff df">
    <div class="df staff-list-bg fdc saas-staff-lt">
      <div class="list-hd df justify-between">
        <div class="df">
          <el-button class="cre-activity-btn" @click="addStaff" type="danger">添加员工</el-button>
          <el-button class="cre-activity-btn btn-join" @click="showInvite" type="danger">邀请加入</el-button>
        </div>
        <div>
          <el-select
            v-model="activityStatus"
            placeholder="员工状态"
            class="select-activity"
            @change="handleStatusChange"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input placeholder="搜索员工" v-model="keyword" class="input-search">
            <el-button slot="append" icon="el-icon-search" @click="handleKeywordSearch"></el-button>
          </el-input>
        </div>
      </div>
      <!-- 主体 -->
      <div class="list-bd">
        <el-table :data="tableData" stripe class="market-table" empty-text="暂无数据哦～" v-loading.body="isloading">
          <el-table-column prop="account" label="账号" width="367" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" min-width="126" align="center"></el-table-column>
          <el-table-column prop="position" label="职位" min-width="126" align="center"></el-table-column>
          <el-table-column prop="status_desc" label="状态" min-width="66" align="center"></el-table-column>
          <el-table-column label-class-name="table-item-edit" align="left" label="操作" width="251">
            <template slot-scope="scope">
              <span class="operator-btn" :class="rolesApi.indexOf('api_admin_get_staff_detail')>=0  ? '':'vishi'" v-if="scope.row.status == 0 || scope.row.status == 2 || scope.row.status == 3" @click="showConfirm(['info', scope.row.user_id])">查看</span>
              <span class="operator-btn" :class="rolesApi.indexOf('api_admin_staff_audit')>=0  ? '':'vishi'" v-if="scope.row.status == 2 || scope.row.status == 3" @click="showConfirm(['audit', scope.row.user_id,scope.row.status])">审核</span>
              <span class="operator-btn" :class="rolesApi.indexOf('api_admin_update_staff_v2')>=0  ? '':'vishi'" v-if="scope.row.status == 1" @click="showConfirm(['edit', scope.row.user_id])">编辑</span>
              <span class="operator-btn" :class="rolesApi.indexOf('api_admin_staff_resign')>=0  ? '':'vishi'" v-if="scope.row.status == 1" @click="showConfirm(['leave', scope.row.user_id])">离职</span>
              <span class="operator-btn" :class="rolesApi.indexOf('api_admin_staff_entry')>=0  ? '':'vishi'" v-if="scope.row.status == 0" @click="showConfirm(['join', scope.row.user_id])">入职</span>
              <span class="operator-btn" :class="rolesApi.indexOf('api_admin_get_staff_card')>=0  ? '':'vishi'" v-if="scope.row.status == 1" @click="showConfirm(['card', scope.row.user_id])">名片</span>
            </template>
          </el-table-column>
        </el-table>
        <lay-page
          @changePage="changePage"
          :page="pagination.current_page"
          :perPage="pagination.per_page"
          :total="pagination.total"
          :totalPage="pagination.total_page"
        ></lay-page>
      </div>
    </div>
    <!-- 员工邀请 -->
    <pop-invite
      v-if="invitepop"
      :showPopAdd="invitepop"
      @popfn="hideInvite"
      :link="shareLink"
      :codeImg="codeImg"
    ></pop-invite>
    <!-- 审核 -->
    <!-- 离职 -->
    <!-- 入职 -->
    <el-dialog
      :visible.sync="confirmpop"
      width="30%"
      :title="confirmData[confirmStatus].class"
      v-if="confirmpop"
      :custom-class="confirmStatus != 3 ? 'confirm-pop normal-pop': 'confirm-pop card-pop'"
    >
      <div class="confirm-content" v-if="confirmStatus != 3">
        <h2 class="t18">{{confirmData[confirmStatus].title}}</h2>
        <p class="mt-10 t14">{{confirmData[confirmStatus].content}}</p>
      </div>
      <!-- 名片 -->
      <div class="card-content df fdc" v-if="confirmStatus == 3">
        <div class="card-info df mb-40 justify-between">
          <div class="card-avatar bdr-5p oh mr-20">
            <img :src="!cardinfo.photo?cardinfo.avatar:$url(cardinfo.photo)" alt class="wh100p" />
          </div>
          <div class="card-info-content df fdc tl">
            <div class="card-sname-bg df  mb-10">
              <div class="card-sname t18 tb tcut">{{cardinfo.name}}</div>
              <div class="card-position t14 ml-10">{{cardinfo.position}}</div>
            </div>
            <div class="card-store t16 tcut">{{cardinfo.seller_name}}</div>
          </div>
          <div class="card-qrcode">
            <img :src="cardinfo.qrcode && cardinfo.qrcode.image_url" alt class="wh100p" />
          </div>
        </div>
        <p class="card-static t12 m-0" :class="confirmStatus==3 ? 'tips-color' : ''">{{confirmData[confirmStatus].content}}</p>
      </div>
      <span slot="footer" class="dialog-footer" v-if="confirmStatus != 3">
        <el-button @click="confirmYes" class="confirm-yes" type="danger">确 定</el-button>
        <el-button @click="confirmNo" class="confirm-no">{{confirmStatus == 0 ? '不通过' : '取 消'}}</el-button>
      </span>
    </el-dialog>
    <!-- 帮助中心 -->
    <!-- <help-btn @showCenter="showCenter" v-show="!isHelp"></help-btn> -->
    <!-- <help-center @hideCenter="hideCenter" v-show="isHelp"></help-center> -->
  </div>
</template>

<script>
  import popInvite from "@/components/popover/popInvite.vue";
  import layPage from "@/components/layout/pagination.vue";
  import helpMixins from "@/mixins/helpCenter";
  export default {
    name: "saasStaff",
    components: {
      popInvite,
      layPage,
    },
    mixins: [helpMixins],
    data() {
      return {
        isloading: true,
        invitepop: false,
        confirmpop: false,
        confirmStatus: null, // 0 审核 1 离职 2 入职 3名片
        confirmData: [
          {
            class: "审核",
            title: "确定审核通过吗？",
            content:
              "审核通过后即成为员工，可以查看公司的数据。若操作失误可把该员工设为离职即可。",
          },
          {
            class: "离职",
            title: "确定该员工离职吗？",
            content:
              "离职后账号将与公司解绑，无法登录当前公司后台且无法查看该公司数据，请谨慎操作！",
          },
          {
            class: "入职",
            title: "确定该员工入职吗？",
            content:
              "入职后账号将与公司绑定，可登录当前公司后台且查看该公司数据，请谨慎操作！",
          },
          {
            class: "名片",
            avatar:
              "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
            content:
              "您可以将此二维码通过网上或线下宣传展示给您的客户，客户使用手机扫描该二维码，就可以访问您的个人名片了。",
          },
        ],
        cardinfo: {},
        auditpop: false,
        leavepop: false,
        joinpop: false,
        cardpop: false,
        activityStatus: "",
        keyword: "",
        tableData: [],
        pagination: {},
        options: [
          {
            value: "",
            label: "全部",
          },
          {
            value: "1",
            label: "在职",
          },
          {
            value: "2",
            label: "待审核",
          },
          {
            value: "3",
            label: "审核不通过",
          },
        ],
        shareLink: "",
        codeImg: "",
        clickUserId: null
      };
    },
    created() {
      this.init();
    },
    computed:{
       rolesApi: {
        get: function () {
          return this.$store.state.rolesApi;
        },
        set: function () {},
      },
    },
    methods: {
      init() {
        this.getStaff();
      },
      // 员工列表查询
      getStaff(
        page = 1,
        per_page = 15,
        status = this.activityStatus,
        keywords = this.keyword
      ) {
        this.isloading = true
        this.$axios
          .get("/api/v2/admin/getAllStaffs", {
            params: { page, per_page, status, keywords },
          })
          .then((res) => {
            if (res.data.status == "200") {
              this.tableData = res.data.data.data;
              this.pagination = res.data.data.meta.pagination;
              this.isloading = false
            } else {
              this.$popup(res.data.msg, "error");
              this.isloading = false
            }
          })
          .catch((error) => {
            this.$popup(error, "error");
            this.isloading = false
          });
      },
      // 状态切换
      handleStatusChange(val) {
        this.getStaff();
      },
      // 关键字搜索
      handleKeywordSearch(val) {
        this.getStaff();
      },
      // 跳转页码
      changePage(page) {
        this.getStaff(page);
      },
      // 员工邀请
      showInvite() {
        this.invitepop = !this.invitepop;
        this.$axios
          .get("/api/v1/admin/getinvitation")
          .then((res) => {
            if (res.data.status == "200") {
              this.shareLink = res.data.data.url;
              this.codeImg = res.data.data.image_url;
            } else {
              this.$popup(res.data.msg, "error");
            }
          })
          .catch((error) => {
            this.$popup(error, "error");
          });
      },
      hideInvite() {
        this.invitepop = false;
      },
      toggleConfirm() {
        this.confirmpop = !this.confirmpop;
      },
      // 确定框
      showConfirm(e) {
        let user_id = e[1];
        this.clickUserId = user_id;
        switch (e[0]) {
          case "info":
            this.staffInfo(user_id);
            break;
          case "audit":
            this.toggleConfirm();
            this.confirmStatus = 0;
            break;
          case "edit":
            this.editStaff(user_id);
            break;
          case "leave":
            this.toggleConfirm();
            this.confirmStatus = 1;
            break;
          case "join":
            this.toggleConfirm();
            this.confirmStatus = 2;
            break;
          case "card":
            this.cardinfo = {
              class: "名片",
              seller_name: "拼命加载中...",
              avatar:
                "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
            };
            this.lookCard(user_id);
            this.confirmStatus = 3;
            this.toggleConfirm();
            break;

          default:
            console.log("不存在的操作");
            break;
        }
      },
      confirmYes() {
        let status = this.confirmStatus;
        if (status == 0) {
          //审核
          this.$axios({
            method: "post",
            url: "/api/v1/admin/staff/audit",
            data: { user_id: this.clickUserId, confirm: 1 },
          })
            .then((res) => {
              this.clickUserId = null;
              if (res.data.status == "200") {
                this.$popup("审核成功", "success");
                this.getStaff(this.pagination.current_page);
              } else if (res.data.status == "400") {
                this.$popup(res.data.msg, "error");
              }
            })
            .catch(function (error) {});
        } else if (status == 1) {
          // 离职
          this.$axios({
            method: "post",
            url: "/api/v1/admin/staff/resign",
            data: { user_id: this.clickUserId },
          })
            .then((res) => {
              this.clickUserId = null;
              if (res.data.status == "200") {
                this.$popup("操作成功", "success");
                this.getStaff(this.pagination.current_page);
              } else if (res.data.status == "400") {
                this.$popup(res.data.msg, "error");
              }
            })
            .catch(function (error) {});
        } else if (status == 2) {
          // 入职
          this.$axios({
            method: "post",
            url: "/api/v1/admin/staff/entry",
            data: { user_id: this.clickUserId },
          })
            .then((res) => {
              this.clickUserId = null;
              if (res.data.status == "200") {
                this.$popup("入职成功", "success");
                this.getStaff(this.pagination.current_page);
              } else if (res.data.status == "400") {
                this.$popup(res.data.msg, "error");
              }
            })
            .catch(function (error) {});
        }
        this.toggleConfirm();
        // swith case 处理
      },
      confirmNo() {
        this.toggleConfirm();
        // 判断是否是审核
        let status = this.confirmStatus;
        if (status == 0) {
          //审核 不通过
          this.$axios({
            method: "post",
            url: "/api/v1/admin/staff/audit",
            data: { user_id: this.clickUserId, confirm: 0 },
          })
            .then((res) => {
              this.clickUserId = null;
              if (res.data.status == "200") {
                this.$popup("操作成功", "success");
                this.getStaff(this.pagination.current_page);
              } else if (res.data.status == "400") {
                this.$popup(res.data.msg, "error");
              }
            })
            .catch(function (error) {});
        }
      },
      addStaff() {
        // 需要做刷新处理
        this.$store.dispatch("addHeadTab", {
          addTitle: "添加员工",
          addUrl: "staff-add",
        });
      },
      editStaff(user_id) {
        this.$store.dispatch("addHeadTab", {
          addTitle: "编辑员工",
          addUrl: "staff-edit",
          query: {
            user_id,
          },
        });
      },
      staffInfo(user_id) {
        this.$store.dispatch("addHeadTab", {
          addTitle: "查看员工",
          addUrl: "staff-info",
          query: {
            user_id,
          },
        });
      },
      // 查看名片
      lookCard(user_id) {
        this.$axios
          .get("/api/v1/admin/staff/card", { params: { user_id } })
          .then((res) => {
            if (res.data.status == "200") {
              this.cardinfo = { ...this.confirmData[3], ...res.data.data };
            } else {
              this.$popup(res.data.msg, "error");
            }
          })
          .catch((error) => {
            this.$popup(error, "error");
          });
      },
    },
  };
</script>
<style scoped lang='less'>
  .saas-staff {
    top: 0;
    bottom: 0;
    height: 100%;
    text-align: initial;
    width: 100%;
    .tips-color{
      color:#747B94;
    }
    .saas-staff-lt {
      background: #fff;
      border-radius: 10px;
      height: calc(100vh - 100px);
      padding: 20px;
      position: relative;
      width: 100%;
      box-sizing: border-box;
      // el-table无法自适应bug
      overflow: auto;
      .btn-join {
        margin-left: 20px;
      }
    }
    .cre-activity-btn {
      background: #ff3a3a;
      box-shadow: 0px 6px 11px -5px rgba(255, 82, 82, 1);
      color: #fff;
      border-radius: 5px;
      width: 130px;
      height: 42px;
      padding: unset;
      border: none;
    }
    .select-activity {
      width: 150px;
      height: 42px;
    }
    .input-search {
      width: 260px;
      // height: 42px;
      margin-left: 16px;
      .el-input__inner {
        height: 100%;
        // background: #f4f4f7;
      }
      /deep/ .el-input__inner:focus {
        border-color: #2b3f57;
      }
      /deep/ .el-input-group__append {
        padding-left: 12px;
        padding-right: 12px;
        background-color: #fff;
        font-size: 20px;
      }
    }
    /deep/ .el-select .el-input.is-focus .el-input__inner {
      border-color: #2b3f57;
    }
    /deep/ .el-select .el-input__inner:focus {
      border-color: #000;
    }
    .market-table {
      margin-top: 20px;
      /deep/ .table-item-edit {
        .cell {
          text-indent: 28%;
        }
      }
    }
    .market-table table {
      color: #2b3f57 !important;
    }
    /deep/ .el-table__row {
      td:last-child {
       
        .cell .operator-btn:not(last-child) {
          margin-right:41px;
          // display: flex;
          // justify-content: space-around;
        }
      }
    }
    .operator-btn {
      cursor: pointer;
      color: @LINKCOLOR;
    }
    table .market-table-header {
      div {
        color: #2b3f57 !important;
        font-weight: bold !important;
      }
    }
    .el-pagination {
      position: absolute;
      bottom: 38px;
      right: 0;
      font-weight: 500;
    }
    /deep/ .el-table__empty-block {
      background-image: url("~@/assets/images/empty@2x.png");
      background-repeat: no-repeat;
      background-size: 230px 193px;
      background-position: center center;
      height: 700px !important;
    }
    .el-table__empty-block .el-table__empty-text {
      bottom: 30%;
    }
    /deep/ .el-dialog.normal-pop{
      .el-dialog__header {
        display: none;
      }
    }
    // 确定框的样式
    /deep/ .el-dialog.confirm-pop {
      max-width: 500px;
      color: @SAASFONTCOLOR;
      border-radius: 10px;
      &.card-pop {
        max-width: 464px;
      }
      .el-dialog__header {
        padding: 10px 20px;
        border-radius: 10px 10px 0px 0px;
        background-color: @SAASBGCOLOR;
        position: relative;
        .el-dialog__headerbtn {
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .el-dialog__body {
        padding: 40px 20px;
        color: @SAASFONTCOLOR;
        .card-info {
          align-items: center;
        }
        .card-avatar {
          width: 70px;
          height: 70px;
        }
        .card-qrcode {
          width: 90px;
          height: 90px;
        }
        .card-info-content {
          flex: 1;
          // margin-left: -50px;
        }
      }
      .el-dialog__footer {
        padding: 0 0 40px 0;
        text-align:center;
        .el-button {
          width: 130px;
          height: 42px;
        }
        .confirm-yes {
          background-color: @SAASCOLOR;
        }
        .confirm-no {
          margin-left: 18px;
          border-color: inherit;
          color: inherit;
          &:hover {
            color: inherit;
            background-color: inherit;
            border-color: inherit;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/staff-list.vue